import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import List from "../components/List";
import styles from "../assets/css/InRequest.module.css";
import { BASE_URL } from "../constants/constants";

const InRequest = () => {
  const [request, setRequest] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const getRequest = (id) => {
    axios
      .get(`${BASE_URL}/v0/drivers/${id}`, { headers })
      .then((response) => {
        console.log("Request data:", response.data.result);
        setRequest(response.data.result);
      })
      .catch((error) => {
        console.error("There was an error fetching the request!", error);
        setRequest(null);
      });
  };

  const confirmRequest = (driverId) => {
    axios
      .post(
        `${BASE_URL}/v0/drivers/${driverId}/confirm`,
        {},
        { headers }
      )
      .then((response) => {
        if (response.data.result) {
          alert("Запрос успешно подтвержден!");
          navigate("/requests");
        } else {
          alert("Не удалось подтвердить запрос!");
        }
        console.log("Confirmation response:", response.data);
      })
      .catch((error) => {
        console.error("Ошибка при подтверждении запроса!", error);
        alert("Ошибка при подтверждении запроса!");
      });
  };

  useEffect(() => {
    if (id) {
      console.log("Fetching data for ID:", id);
      getRequest(id);
    } else {
      console.error("ID is not defined!");
    }
  }, [id]);

  const openModal = (imageSrc) => {
    const fullImageUrl = `${BASE_URL}/v0/${imageSrc}`;
    setSelectedImage(fullImageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  if (request === null) {
    return (
      <div>
        <Header />
        <div className={styles.container}>
          <List />
          <div className={styles.container1}>
            <div className={styles.box}>
              <div
                onClick={() => navigate("/requests")}
                className={styles.text}
              >
                Запросы
              </div>
              <img
                className={styles.nexticon}
                src="/images/next.svg"
                alt="next icon"
              />
              <div className={styles.text1}>Загрузка...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div onClick={() => navigate("/requests")} className={styles.text}>
              Запросы
            </div>
            <img
              className={styles.nexticon}
              src="/images/next.svg"
              alt="next icon"
            />
            {request.mainInfo ? (
              <div className={styles.text1}>
                {request.mainInfo.firstName} {request.mainInfo.lastName}
              </div>
            ) : (
              <div className={styles.text1}>Загрузка...</div>
            )}
          </div>

          <div className={styles.container2}>
            <div className={styles.box1}>
              {request.mainInfo && (
                <div className={styles.text2}>
                  {request.mainInfo.firstName} {request.mainInfo.lastName}
                </div>
              )}
              <button
                className={styles.acceptbtn}
                onClick={() => confirmRequest(id)}
              >
                Принять запрос
              </button>
            </div>
            {request.mainInfo ? (
              <div className={styles.wholeblock}>
                <div className={styles.boxuser}>
                  <img
                    className={styles.image}
                    src={
                      request.mainInfo.imageSrc
                        ? `${BASE_URL}/v0/${request.mainInfo.imageSrc}`
                        : "/images/drivers.svg"
                    }
                    alt="driver avatar"
                  />
                  <div className={styles.box5}>
                    <div className={styles.text3}>Данные запроса</div>
                    <div className={styles.box6}>
                      <div className={styles.type}>Имя:</div>
                      <div className={styles.type1}>
                        {request.mainInfo.firstName} {request.mainInfo.lastName}
                      </div>
                    </div>
                    <div className={styles.box6}>
                      <div className={styles.type}>Номер телефона:</div>
                      <div className={styles.type1}>
                        {request.mainInfo.phoneNumber}
                      </div>
                    </div>
                    <div className={styles.box6}>
                      <div className={styles.type}>Дата рождения:</div>
                      <div className={styles.type1}>
                        {request.mainInfo.birthDate}
                      </div>
                    </div>
                    <div className={styles.box6}>
                      <div className={styles.type}>ИИН:</div>
                      <div className={styles.type1}>
                        {request.driverUIN.uin}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.licencebox}>
                  <div className={styles.text3}>Водительские права</div>
                  <div className={styles.box6}>
                    <div className={styles.type}>
                      Водительское удостоверение:
                    </div>
                    <div className={styles.type1}>
                      {request.driverLicense.licenseID}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Дата истечения:</div>
                    <div className={styles.type1}>
                      {request.driverLicense.expiryDate}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>
                      Лицевая сторона водительского удостоверения:
                    </div>
                    <div
                      onClick={() =>
                        openModal(request.driverLicense.licenseFrontSide)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>
                      Обратная сторона водительского удостоверения:
                    </div>
                    <div
                      onClick={() =>
                        openModal(request.driverLicense.licenseBackSide)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Фото с удостоверением:</div>
                    <div
                      onClick={() =>
                        openModal(request.driverLicense.selfieWithLicense)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                </div>

                <div className={styles.carbox}>
                  <div className={styles.text3}>Данные о транспорте</div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Марка транспорта:</div>
                    <div className={styles.type1}>
                      {request.transportInfo.make}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Модель транспорта:</div>
                    <div className={styles.type1}>
                      {request.transportInfo.model}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Цвет транспорта:</div>
                    <div className={styles.type1}>
                      {request.transportInfo.color}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Цвет транспорта:</div>
                    <div className={styles.type1}>
                      {request.transportInfo.carNumber}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Год выпуска:</div>
                    <div className={styles.type1}>
                      {request.transportInfo.carYear}
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>
                      Лицевая сторона сертификата:
                    </div>
                    <div
                      onClick={() =>
                        openModal(request.transportInfo.certificateFrontSide)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>
                      Обратная сторона сертификата:
                    </div>
                    <div
                      onClick={() =>
                        openModal(request.transportInfo.certificateBackSide)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                  <div className={styles.box6}>
                    <div className={styles.type}>Фото транспорта:</div>
                    <div
                      onClick={() =>
                        openModal(request.transportInfo.carFrontImage)
                      }
                      className={styles.type2}
                    >
                      фото
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.text3}>Загрузка...</div>
            )}
            <div className={styles.box2}>
              <button
                onClick={() => navigate("/requests")}
                className={styles.deletebtn}
              >
                Назад
              </button>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <img src={selectedImage} alt="Large View" />
            <button onClick={closeModal} className={styles.closeButton}>
              X
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InRequest;
